import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/types";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  type DragEndEvent,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { Paper } from "@mui/material";
import DragList from "./DragList";
import {
  getReOrderedTablist,
  type TabOrderItem,
} from "../../../../services/settings";
import { getReOrderedTablistSelector } from "../../../../selectors/settingsSelector";

const DragItem = () => {
  const dispatch = useAppDispatch();

  const reOrderedTablist = useAppSelector(getReOrderedTablistSelector) as
    | TabOrderItem[]
    | null;

  const [tabOrders, setTabOrders] = useState<TabOrderItem[]>([]);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  useEffect(() => {
    reOrderedTablist && setTabOrders(reOrderedTablist);
  }, [reOrderedTablist]);

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;

    if (!over || active.id === over.id) {
      return;
    }

    const oldIndex = tabOrders.findIndex((item) => item.tabId === active.id);
    const newIndex = tabOrders.findIndex((item) => item.tabId === over.id);

    const newItems = arrayMove(tabOrders, oldIndex, newIndex);
    setTabOrders(newItems);
    dispatch(getReOrderedTablist(newItems));
  };

  const itemIds = tabOrders.map((item) => item.tabId);

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext items={itemIds} strategy={verticalListSortingStrategy}>
        <Paper
          elevation={1}
          sx={{
            padding: 2,
            marginTop: 1,
            width: "83%",
            height: "230px",
            overflowX: "hidden",
            overflowY: "auto",
          }}
        >
          <DragList elements={tabOrders} />
        </Paper>
      </SortableContext>
    </DndContext>
  );
};

export default DragItem;
